import { deriveE2eeRoomBinding } from './e2ee-invitation.js';
import type { SecureMeetingInvitation } from './meeting-invite-client.js';

/** Recover only the key belonging to the current meeting and its authenticated binding. */
export async function recoverKeyFromInvitation(
  invitation: SecureMeetingInvitation | null,
  meetingId: string,
  expectedBinding: string | undefined,
): Promise<Uint8Array | null> {
  if (!invitation || invitation.meetingId !== meetingId || !invitation.encryptionKey || !expectedBinding) return null;
  const key = new Uint8Array(invitation.encryptionKey);
  try {
    if (await deriveE2eeRoomBinding(meetingId, key) !== expectedBinding) return null;
    return new Uint8Array(key);
  } finally {
    key.fill(0);
  }
}
